import BaseModel from './base_model'

export default class Amenity extends BaseModel {
  title: string
  icon: string
  category: string
  description: string
  imdf: string | null
  type: 'amenity' | 'occupant'

  constructor(data: any) {
    super(data)
    this.title = data.title
    this.icon = data.icon
    this.category = data.category
    this.description = data.description
    this.imdf = data.imdf ? data.imdf : null
    this.type = data.type ? data.type : 'amenity'
  }

  hasIcon() {
    return this.icon && this.icon.match(/data:image/)
  }
}
